import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import TruthrPrivacy from "../views/TruthrPrivacy.vue";
import TruthrSupport from "../views/TruthrSupport.vue";
import TruthrEULA from "../views/TruthrEULA.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    alias: "/About",
    name: "About",
    component: TruthrPrivacy,
  },
  {
    path: "/products",
    alias: "/Products",
    name: "Products",
    component: TruthrSupport,
  },
 // {
 //   path: "/ClientLogin",
 //   name: "ClientLogin",
 //   component: TruthrEULA,
 // },
  {
    path: "/dog",
    name: "dog",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0 };
  },
});

export default router;
